var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_189",
    "data-name": "Group 189",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "settings-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 48,
    height: 48,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    clipPath: "url(#settings-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M45.392,19.678l-4.152-.831a17.966,17.966,0,0,0-1.4-3.4l2.346-3.52a2,2,0,0,0-.25-2.524L38.594,6.068a2,2,0,0,0-2.523-.25L32.536,8.174a17.938,17.938,0,0,0-3.385-1.417l-.83-4.149A2,2,0,0,0,26.36,1H21.639a2,2,0,0,0-1.961,1.608l-.83,4.149a17.77,17.77,0,0,0-3.389,1.414l-3.53-2.353a2,2,0,0,0-2.524.25L6.067,9.406a2,2,0,0,0-.25,2.524l2.357,3.535a17.953,17.953,0,0,0-1.41,3.382l-4.156.831A2,2,0,0,0,1,21.639v4.722a2,2,0,0,0,1.608,1.96l4.152.83a17.8,17.8,0,0,0,1.4,3.4L5.817,36.07a2,2,0,0,0,.25,2.524L9.4,41.932a2,2,0,0,0,2.524.25l3.535-2.357a17.891,17.891,0,0,0,3.384,1.417l.83,4.15A2,2,0,0,0,21.639,47H26.36a2,2,0,0,0,1.961-1.608l.831-4.152a17.858,17.858,0,0,0,3.4-1.405l3.52,2.347a2,2,0,0,0,2.523-.25l3.338-3.338a2,2,0,0,0,.25-2.524l-2.356-3.535a17.953,17.953,0,0,0,1.416-3.384l4.15-.83A2,2,0,0,0,47,26.361V21.639A2,2,0,0,0,45.392,19.678Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M28.211,14.927a9.992,9.992,0,1,0,4.862,4.862",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.96ae6c66002c86c7a2966ce6f3d4823b.svg";
export { ForwardRef as ReactComponent };